import React from 'react';
import UploadingPopupAnimation from "../../UploadingPopupAnimation";
import CsvUploadLoaderBackground from "../../../assets/images/loading-data-placeholder.png";
import {useTranslation} from "react-i18next";

const ValidateCsv = ({onClose, ...props}) => {
    const { t } = useTranslation();
    return (
        <div className="step">
            <div className="validate-csv">
                <h4>CSV Field Details Uploading...</h4>
                <UploadingPopupAnimation title={t("CSV Uploading...")} description={t("Please wait...")}
                                         onClose={onClose}/>
                <img src={CsvUploadLoaderBackground} alt="CSV Upload Loader Backbround"
                     className="csv-upload-loader-background"/>
            </div>
        </div>
    );
};

export default ValidateCsv;
